module.exports = __webpack_public_path__ + "img/tools.cc729cee.jpg";